<div id="top-of-page"></div>

<div *ngIf="isFetching" class="progress-bar-container">
  <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
</div>

<mat-toolbar color="primary" class="app-toolbar no-print" [class.transitioning]="isTransitioning">
  <mat-toolbar-row>
    <button mat-button class="hamburger" [class.starting]="isStarting" (click)="sidenav.toggle()" title="Docs menu">
      <mat-icon svgIcon="menu"></mat-icon>
    </button>
    <a class="nav-link home" href="/guide" [ngSwitch]="isSideBySide" style="margin-left: 30px; margin-right: 30px;">
      <img *ngSwitchCase="true" src="assets/images/logos/ddoologo_white.svg" width="30" height="30" title="Home" alt="Home" />
      <img *ngSwitchDefault src="assets/images/logos/ddoologo_white.svg" width="25" height="25" title="Home" alt="Home" />
    </a>
    <aio-top-menu *ngIf="isSideBySide" [nodes]="topMenuNodes"></aio-top-menu>
    <aio-search-box class="search-container" #searchBox (onSearch)="doSearch($event)" (onFocus)="doSearch($event)"></aio-search-box>
    <div class="toolbar-external-icons-container">
      <a href="https://ddoo.dev/github" title="GitHub" target="_blank">
        <img src="assets/images/logos/github-icon.svg" alt="View on GitHub"
        /></a>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<aio-search-results
        #searchResultsView
        *ngIf="showSearchResults"
        [searchResults]="searchResults | async"
        (resultSelected)="hideSearchResults()"
></aio-search-results>

<mat-sidenav-container class="sidenav-container" [class.starting]="isStarting" [class.has-floating-toc]="hasFloatingToc">
  <mat-sidenav
          [ngClass]="{ collapsed: !isSideBySide }"
          #sidenav
          class="sidenav"
          [mode]="mode"
          [opened]="isOpened"
          (openedChange)="updateHostClasses()"
  >
    <aio-nav-menu
            *ngIf="!isSideBySide"
            [nodes]="topMenuNarrowNodes"
            [currentNode]="currentNodes.TopBarNarrow"
            [isWide]="false"
    ></aio-nav-menu>
    <aio-nav-menu [nodes]="sideNavNodes" [currentNode]="currentNodes.SideNav" [isWide]="isSideBySide"></aio-nav-menu>

    <div class="doc-version">
      <aio-select (changeEmitter)="onDocVersionChange($event.index)" [options]="docVersions" [selected]="currentDocVersion"></aio-select>
    </div>
  </mat-sidenav>

  <section class="sidenav-content" [id]="pageId" role="main">
    <aio-mode-banner *ngIf="versionInfo" [mode]="deployment.mode" [version]="versionInfo"></aio-mode-banner>
    <aio-doc-viewer
            [class.no-animations]="isStarting"
            [doc]="currentDocument"
            (docReady)="onDocReady()"
            (docRemoved)="onDocRemoved()"
            (docInserted)="onDocInserted()"
            (docRendered)="onDocRendered()"
    >
    </aio-doc-viewer>
    <aio-dt *ngIf="dtOn" [(doc)]="currentDocument"></aio-dt>
  </section>
</mat-sidenav-container>

<div *ngIf="hasFloatingToc" class="toc-container no-print" [style.max-height.px]="tocMaxHeight" (wheel)="restrainScrolling($event)">
  <aio-lazy-ce selector="aio-toc"></aio-lazy-ce>
</div>

<footer class="no-print">
  <aio-footer [nodes]="footerNodes"></aio-footer>
</footer>
